import { render, staticRenderFns } from "./IntoTab.vue?vue&type=template&id=7dec8fe8&scoped=true&"
import script from "./IntoTab.vue?vue&type=script&lang=js&"
export * from "./IntoTab.vue?vue&type=script&lang=js&"
import style0 from "./IntoTab.vue?vue&type=style&index=0&id=7dec8fe8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dec8fe8",
  null
  
)

export default component.exports